/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { createStyles, makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import SINGUP_BACKGROUND from "../../assets/img/landing_main_background.png";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      padding: "15px",
      minHeight: "750px",
      backgroundImage: `url(${SINGUP_BACKGROUND})`,
      backgroundSize: "cover",
    },
    container85: {
      width: "85%",
      margin: "0 auto",
    },
    projectTitle: {
      fontWeight: "500",
      fontSize: "1.375rem",
      color: "#1f577b",
      marginBottom: "15px",
    },
    colorGray: {
      color: "#919191",
    },
    RegistrationForward: {
      background: "#fff",
      padding: "40px 50px",
      marginTop: "20px",
    },
  })
);

// interface Props {
// 	isLoading: boolean,
// 	classes: Object,
// }

const RegistrationForward = React.memo((/* props: Props */) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const isRegistered = location?.search.includes("?registered=true");

  useEffect(() => {
    if (!isRegistered) {
      // redirect the user to another page if they're not registered
      navigate("/");
    }
  }, []);

  return (
    <Typography component="div" className={classes.root}>
      <Grid container className={classes.container85}>
        <Grid item xs={12} sm={12} className={classes.RegistrationForward}>
          <Typography component="div">
            <Typography variant="h2" className={classes.projectTitle}>
              Sign up
            </Typography>
            <Typography component="p" className={classes.colorGray}>
              Thank you for your registration.
            </Typography>
            <Typography component="p" className={classes.colorGray}>
              We have sent you a confirmation email containing an activation link.
            </Typography>
            <Typography component="p" className={classes.colorGray}>
              Please confirm your registration.
            </Typography>
          </Typography>
        </Grid>
      </Grid>
    </Typography>
  );
});

export default RegistrationForward;
